/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  ContactDetailsCustomFieldItemDto,
  ContactDetailsCustomFieldListDto,
  ContactDetailsPaymentCreditorDto,
  ContactDetailsPaymentPayeeDto,
  ContactDetailsPaymentPayerDto,
  ContactDetailsTermsPayeeDto,
  ContactDetailsTermsPayerDto,
  ContactTermsPayables,
  ContactTermsReceivables,
} from '@gh/builder-shared-data';

export type ContactCustomFieldItem = ContactDetailsCustomFieldItemDto;
export type ContactCustomFieldList = ContactDetailsCustomFieldListDto;
export type ContactPaymentPayer = ContactDetailsPaymentPayerDto;
export type ContactPaymentPayee = ContactDetailsPaymentPayeeDto | ContactDetailsPaymentCreditorDto;
export type ContactTermsPayer = ContactDetailsTermsPayerDto;
export type ContactTermsPayee = ContactDetailsTermsPayeeDto;

export function isTermsReceivablesAllowDays(due: ContactTermsReceivables): boolean {
  switch (due) {
    case ContactTermsReceivables.InDays:
    case ContactTermsReceivables.OnMonthDay:
    case ContactTermsReceivables.DaysAfterEOM:
    case ContactTermsReceivables.MonthDayAfterEOM:
    case ContactTermsReceivables.DueUponReceipt:
      return true;
    default:
      return false;
  }
}

export function isTermsReceivablesBalanceAsDayOfMonth(due: ContactTermsReceivables): boolean {
  switch (due) {
    case ContactTermsReceivables.OnMonthDay:
    case ContactTermsReceivables.MonthDayAfterEOM:
      return true;
    default:
      return false;
  }
}

export function isTermsReceivablesDueDateRequired(due: ContactTermsReceivables): boolean {
  switch (due) {
    case ContactTermsReceivables.InDays:
    case ContactTermsReceivables.OnMonthDay:
    case ContactTermsReceivables.DaysAfterEOM:
    case ContactTermsReceivables.MonthDayAfterEOM:
      return true;
    default:
      return false;
  }
}

export function isTermsPayablesAllowDays(due: ContactTermsPayables): boolean {
  switch (due) {
    case ContactTermsPayables.InDays:
    case ContactTermsPayables.OnMonthDay:
    case ContactTermsPayables.DaysAfterEOM:
    case ContactTermsPayables.MonthDayAfterEOM:
      return true;
    default:
      return false;
  }
}

export function isTermsPayablesBalanceAsDayOfMonth(due: ContactTermsPayables): boolean {
  switch (due) {
    case ContactTermsPayables.OnMonthDay:
    case ContactTermsPayables.MonthDayAfterEOM:
      return true;
    default:
      return false;
  }
}

export function isTermsPayablesDueDateRequired(due: ContactTermsPayables): boolean {
  switch (due) {
    case ContactTermsPayables.InDays:
    case ContactTermsPayables.OnMonthDay:
    case ContactTermsPayables.DaysAfterEOM:
    case ContactTermsPayables.MonthDayAfterEOM:
      return true;
    default:
      return false;
  }
}
